import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { CroppedAsset as CroppedAssetModel } from 'models';
import { croppedImageUrl, isVideo } from 'common/methods/string';
import ds, { media } from 'designsystem';

const CropContainer = styled.div`
  position: ${({ absolute }) => (absolute ? 'absolute' : 'relative')};
  top: 0;
  left: 0;
  overflow: hidden;

  ${({
    params: {
      width,
      height,
      marginLeft,
      marginTop,
    },
	}) => (`
    width: ${width};
		height: ${height};
		margin-left: ${marginLeft};
		margin-top: ${marginTop};`
  )}
`;

const Header = styled.div`
  flex: 0 1 auto;
  font-family: ${ds.get('type.fontFamily.headline')};
  margin-top: calc(${ds.get('metrics.xl')});
  margin-bottom: ${ds.get('metrics.s')};
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${media.desktop`
    margin-top: calc(${ds.get('metrics.xl')} * 2);
    margin-bottom: ${ds.get('metrics.xl')};
  `}

  ${media.xLargeDesktop`
    margin-top: calc(${ds.get('metrics.xl')} * 2);
    margin-bottom: calc(${ds.get('metrics.xl')} * 2);
  `}

  .title {
    font-weight: ${ds.get('type.fontWeight.bold')};
    font-size: ${ds.fs('xl')};
    color: ${ds.brand('product')};

    ${media.desktop`
      font-size: ${ds.fs('xxl')};
    `}
  }

  .subtitle {
    font-weight: ${ds.get('type.fontWeight.extended')};
    font-size: ${ds.fs('m')};
    margin-top: ${ds.get('metrics.base')}

    ${media.desktop`
      font-size: ${ds.fs('l')};
    `}
  }
`;

const YouTubeContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  width: 1366px;

  .iframe-wrapper {
    position: relative;
    padding-bottom: 56.25%; 
    height: 0;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 20px;
    width: calc(100% - 40px);
    height: 100%;
  }

  ${media.xLargeDesktop`
    display: flex;
    margin: auto;
    
    .iframe-wrapper {
      flex: 1 0 50%;
    }

    iframe {
      left: 0;
      width: 100%;
      height: 50%;
      transform: translateY(50%);
    }
  `}
`;

const CroppedImage = styled.img``;

const CroppedVideo = styled.video`
  object-fit: cover;
  ${({ params: { width, height } }) =>
    `
    width: ${width};
    height: ${height};
  `}
`;

const EmbedYouTube = ({ data }) => (
  <YouTubeContainer>
    <Header>
      {data.title && (<div className="title">{data.title}</div>)}
      {data.subtitle && (<div className="subtitle">{data.subtitle}</div>)}
    </Header>
    <div className="iframe-wrapper">
      <iframe
        title="youTubeSrc"
        src={data.youTubeSrc}
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
  </YouTubeContainer>
);

const CroppedAsset = ({ data, absolute }) => {
    if (data.youTubeSrc) {
      return <EmbedYouTube data={data} />;
    }
    return isVideo(data.asset) ? (
    <CropContainer params={data} absolute={absolute}>
      <CroppedVideo src={data.asset} params={data} muted loop autoPlay />
    </CropContainer>
    ) : (
    <CropContainer params={data} absolute={absolute}>
      <CroppedImage
        src={`${croppedImageUrl(data.asset, data.width, data.height)}`}
      />
    </CropContainer>
  )
};

CroppedAsset.propTypes = {
  data: PropTypes.instanceOf(CroppedAssetModel).isRequired,
  absolute: PropTypes.bool,
};

CroppedAsset.defaultProps = {
  absolute: false,
};

export default CroppedAsset;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CroppedAsset/index.jsx